import { copyFun } from '@/utils/common';
import {
	productStatus,
	promoteStatus,
	cooperationStatus,
	deliveryStatus,
	refuseDelivery,
	affirmStatus,
	changeStatus,
	PLATFORM_KS,
	sampleStutas,
} from '@/utils/dataMap';
import { debounce } from 'lodash';
export const getButtons = (that, item) => {
	const isKsPlatform = +item.platform_id === +PLATFORM_KS.value;
	const copyText = isKsPlatform ? '复制ID' : '复制链接';
	const refuseDeliverStatus = 400;
	// 合作进度已暂停
	const isPauseCooperate = +item.cooperate_status === +cooperationStatus.pause;
	// 商品是否已下架
	const isProductTakedOff = +item.product_status === +productStatus.down;

	// 商品是否已停止推广
	const isPromoteClose = +item.promote_status == +promoteStatus.close;

	// 物流未发货
	const hasNotDeliver = +item.delivery_status === +deliveryStatus.notShipped;
	// 物流是否已到货
	const isDeliverArrived = +item.delivery_status == +deliveryStatus.arrived;
	// 是否拒绝发货
	const isRefuseDelivery = +item.is_refuse_delivery == +refuseDelivery.yes;

	// 商品机制是否改变
	const isGoodsChange = +item.is_change == +changeStatus.yes;
	// 是否拒绝带货
	const isRefuseSellGoods = +item.is_affirm == +affirmStatus.refuse;
	//待发货
	const tobeShipped = +item.delivery_status === +sampleStutas.tobeShipped;
	//确认带货
	const confirmDelivery = +item.order_other_status == +sampleStutas.confirmDelivery;
	//已关闭
	const Closed = +item.order_other_status == +sampleStutas.Closed;
	//待审核
	const Audit = +item.order_other_status === +sampleStutas.Audit;
	//审核不通过
	const noPass = +item.order_other_status === +sampleStutas.noPass;
	//待同步
	const waitSellerSync = item.order_cooperate_status === '1';
	//待商家处理
	const waitSellerOpear = item.order_cooperate_status === '2';
	//商家处理中
	const sellerOpearing = item.order_cooperate_status === '3';
	//同步失败
	const failSellerOpear = item.order_cooperate_status === '5';

	// 普通复制链接/ID

	const normalCopyLink = {
		label: copyText,
		type: 'text',
		isShow: true,
		classtype: 2,
		click: row => copyFun(row, that),
	};
	const viewDeliverInfo = {
		label: '查看样品信息',
		type: 'text',
		isShow: item.delivery_address && item.delivery_address.province && that.$auth.hasPermi('system:sampleOder:sample-information'),
		classtype: 2,
		click: row => that.showLogisticsDetailDrawer(row),
	};
	const reissueSample = {
		label: '补寄样品申请',
		type: 'text',
		isShow:
			!hasNotDeliver &&
			item.other_status !== refuseDeliverStatus &&
			that.cooperation &&
			that.$auth.hasPermi('system:sample:merchant:additional-samples'),

		classtype: 2,
		click: that.showReissueDrawer,
	};
	const modifyGoods = {
		label: '修改商品机制',
		type: 'text',
		isShow: !isProductTakedOff && !isPromoteClose && that.$auth.hasPermi('system:sampleOrder:Commodity-mechanism'),
		classtype: 2,
		click: (row, tabName) => that.editProductFun(row, tabName),
	};
	const deliverGoods = {
		label: '发货',
		type: 'text',
		classtype: 2,
		isShow: hasNotDeliver && !isRefuseDelivery && that.$auth.hasPermi('system:sampleOrder:deliver'),
		click: (row, tabName) => {
			if (waitSellerOpear || sellerOpearing) return that.$message.warning('协同中的样品订单不允许操作，可取消协作后再操作');
			that.sampleSendGoodsFun(row, tabName, 0);
		},
	};
	const modifyLogisInfo = {
		label: '修改物流信息',
		type: 'text',
		classtype: 2,
		isShow: item.order_num == '1' && !hasNotDeliver && !isRefuseDelivery && that.$auth.hasPermi('system:edit-logistics'),
		click: (row, tabName) => that.sendGoodsFun(row, tabName, 1),
	};
	const refuseDeliver = {
		label: '拒绝发货',
		type: 'text',
		isShow: hasNotDeliver && !isRefuseDelivery && that.$auth.hasPermi('system:sampleOrder:Refusal-delivery'),
		classtype: 2,
		click: (row, tabName) => {
			if (waitSellerOpear || sellerOpearing) return that.$message.warning('协同中的样品订单不允许操作，可取消协作后再操作');
			that.refuseFun(row, 1, tabName);
		},
	};
	const changeLId = {
		label: '更换ID',
		type: 'text',
		isShow: isKsPlatform && !isPauseCooperate && that.$auth.hasPermi('system:sampleOder:switchLink'),
		classtype: 2,
		click: (row, tabName) => that.replaceLinkFun(row, tabName, '更换ID'),
	};
	const viewGoodsChangeDetail = {
		label: '查看变更详情',
		type: 'text',
		isShow: isGoodsChange,
		classtype: 2,
		click: (row, tabName) => that.changeDFun(row, tabName),
	};
	const confirmReceipt = {
		label: '确认收货',
		type: 'text',
		isShow: [deliveryStatus.shipped, deliveryStatus.transit].includes(item.delivery_status) && that.$auth.hasPermi('system:sampleOrder:confirm'),
		classtype: 2,
		click: row => {
			that.$refs.takeDialog.show(row.cooperate_id, row.sample_sn);
		},
	};
	const confirmSellGoods = {
		label: '确认带货',
		type: 'text',
		// isShow: !isProductTakedOff && isPromoteOpen && isDeliverArrived && !isRefuseSellGoods,
		isShow: isDeliverArrived && !isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:Confirm-shipmentation'),
		classtype: 2,
		click: (row, tabName) => that.beginFun(row, 2, tabName),
	};
	const refuseSellGoods = {
		label: '拒绝带货',
		type: 'text',
		// isShow: isProductOnline && isPromoteOpen && isDeliverArrived && !isRefuseSellGoods,
		isShow: isDeliverArrived && !isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:RefuseTakeGoods'),
		classtype: 2,
		click: (row, tabName) => that.refuseFun(row, 2, tabName),
	};
	const refuseSellGoodsReason = {
		label: '拒绝带货原因',
		type: 'text',
		isShow: isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:refusingTakeGoods'),
		classtype: 2,
		click: (row, tabName) => that.reasonFun(row, '1', tabName),
	};
	const seeDetails = {
		label: '查看详情',
		type: 'text',
		isShow: true,
		classtype: 2,
		click: (row, tabName) => {
			that.detailsFun(row, tabName, 'hide');
		},
	};

	const refuseDeliverReason = {
		label: '拒绝发货原因',
		type: 'text',
		isShow: isRefuseDelivery && that.$auth.hasPermi('system:sampleOrder:reasons-refusing-goods'),
		classtype: 2,
		click: (row, tabName) => that.reasonFun(row, '1', tabName),
	};

	const delGoodsSample = {
		label: '移除商品',
		type: 'text',
		isShow:
			(isProductTakedOff || isPromoteClose || isRefuseSellGoods || isRefuseDelivery || noPass) &&
			that.$auth.hasPermi('system:sampleOrder:ClosedSample'),
		classtype: 2,
		click: (row, tabName) => that.multiFun({ ...row, sampleOrder: that.sampleOrder }, 8, tabName),
	};
	const lookCard = {
		label: '查看手卡',
		type: 'text',
		isShow: item.hand_card,
		classtype: 2,
		click: that.lookCard,
	};
	const pass = {
		label: '通过',
		type: 'text',
		isShow: Audit && that.$auth.hasPermi('system:sample:merchant-audit'),
		classtype: 2,
		click: ({ cooperate_id: cooperateId, sample_sn: sampleSn }) => {
			if (waitSellerOpear || sellerOpearing) return that.$message.warning('协同中的样品订单不允许操作，可取消协作后再操作');
			that.passFun({ cooperateId, sampleSn });
		},
	};
	const refuse = {
		label: '拒绝',
		type: 'text',
		isShow: Audit && that.$auth.hasPermi('system:sample:merchant-audit'),
		classtype: 2,
		click: ({ cooperate_id: cooperateId, sample_sn: sampleSn }) => {
			if (waitSellerOpear || sellerOpearing) return that.$message.warning('协同中的样品订单不允许操作，可取消协作后再操作');
			that.refuseApplyFun({ cooperateId, sampleSn });
		},
	};
	const syncCollaborate = {
		label: '同步样品协作',
		type: 'text',
		isShow:
			(Audit || hasNotDeliver) &&
			(waitSellerSync || failSellerOpear) &&
			that.cooperationStatus &&
			that.$auth.hasPermi('system:sample:merchant-collaboration'),
		classtype: 2,
		click: debounce(function ({ sample_sn }) {
			return that.syncCollaborateFun({ sample_sn });
		}, 300),
	};
	const cancelCollaborate = {
		label: '取消样品协作',
		type: 'text',
		isShow:
			(Audit || hasNotDeliver) &&
			(waitSellerOpear || sellerOpearing) &&
			that.cooperationStatus &&
			that.$auth.hasPermi('system:sample:merchant-collaboration'),
		classtype: 2,
		click: debounce(function ({ sample_sn }) {
			return that.cancelCollaborateFun({ sampleSnList: [sample_sn] });
		}, 300),
	};
	let arr = [];
	if (confirmDelivery || Closed) {
		arr = [seeDetails];
	} else {
		arr = [
			deliverGoods,
			refuseDeliver,
			pass,
			refuse,
			viewDeliverInfo,
			normalCopyLink,
			cancelCollaborate,
			reissueSample,
			modifyGoods,
			modifyLogisInfo,
			changeLId,
			viewGoodsChangeDetail,
			confirmReceipt,
			confirmSellGoods,
			refuseSellGoods,
			refuseSellGoodsReason,
			refuseDeliverReason,
			delGoodsSample,
			lookCard,
			syncCollaborate,
		];
	}
	let filterArr = arr.filter(item => item.isShow);
	filterArr.showdetailDrawer = that.showDetailDrawer;
	filterArr.showLogisticsDetailDrawer = that.showLogisticsDetailDrawer;
	if (tobeShipped) filterArr.settingRemarks = that.settingRemarks;

	return filterArr;
};
